import { render, staticRenderFns } from "./PresentAbsent.vue?vue&type=template&id=678b9d02"
import script from "./PresentAbsent.vue?vue&type=script&lang=js"
export * from "./PresentAbsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports